module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/crm-central-place/crm-central-place@1x.svg"